import Accessibe from './Accessibe.container'

export default Accessibe
